import { translate, type MessageKey } from "./messages";

export function translateWelcomeCaption(
  captionKey: string | undefined,
  locale: string | null | undefined,
): string | undefined {
  if (!captionKey) {
    return undefined;
  }
  return translate(captionKey as MessageKey, locale);
}
